// Since we are experiencing timeout problems on en-SEA locale, this workaround manually sets higher duration for timeout for this very locale
export const resolveFetchTimeout = (locale: string) => {
  return locale === "en-SEA" ? 30000 : 10000;
};
